import { createAsyncThunk } from "@reduxjs/toolkit";

import * as api from "../api";

export const doGetAllOrdersDispatched = createAsyncThunk("reports/doGetAllOrders", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGetAllOrdersDispatched(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetCountOrdersDispatchedByCompany = createAsyncThunk(
  "reports/doGetCountOrdersDispatchedByCompany",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doGetCountOrdersDispatchedByCompany(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);
